import styled from "styled-components";

export const StyledFeature = styled.div`
    .feature-header{
        position: relative;
        overflow: hidden;

        .shadow{
            position: absolute;
            width: 100%;
            top:0;
            background-color: rgba(0,0,0,0.4);
            height: 100%;
        }
        .feature-video{
            position: absolute;
            min-height: 100%;
            min-width: 100%;
            z-index: -2;
        }
    }
    .feature-main{
        text-align: center;
        padding: 250px 0 450px 0;
        color: white;
        position: relative;
        z-index: 2;

        h1{
            font-weight: 700;
            font-size: 96px;
            line-height: 131px;
        }

        p{
            font-size: 32px;
            line-height: 44px;
            margin: 30px auto;
            width: 40%;
        }
        @media (max-width:992px) {
            h1{
                font-size: 60px;
            }
            p{
                font-size: 20px;
                width: 100%;
            }
        }
        @media (max-width:576px) {
            padding: 300px 0;
            h1{
                font-size: 40px;
                line-height: 54px;
            }
            p{
                margin-top: 15px;
                font-size: 16px;
                line-height: 22px;
            }
        }
    }

    .section-one{
        margin-top: 70px;

        .tree{
            display: flex;
            /* align-items: center; */

            .tree-item{
                display: flex;
                margin-bottom: 65px;
                align-items: center;
                justify-content: space-between;
                
                .tree-wrapper{
                    background: rgba(187, 6, 0, 0.1);
                    border: 2px solid #BB0600;
                    border-radius: 10px;
                    padding: 26px 30px;
                    width: 510px;
                    display: flex;
                    gap: 28px;
                    transition: all 0.3s ease-in-out;

                    &:hover{
                        background-color: #BB0600;
                        color: white;

                        .border{
                            background-color: white;
                        }
                        svg{
                            path{
                                fill:white;
                            }
                        }
                        h4{
                            color: white;
                        }
                    }

                    .border{
                        height: 100px;
                        width: 2px;
                        background-color: #BB0600;
                    }

                    h4{
                        font-weight: 700;
                        font-size: 20px;
                        line-height: 27px;
                        color: #BB0600;
                    }
                    p{
                        font-size: 14px;
                        line-height: 23px;
                        margin-top: 5px;
                    }
                    
                }
                
                .line{
                    width: calc(100% - 510px);
                    background: #BB0600;
                    height: 1px;
                }
            }
            .tree-left{
                width: 50%;
                margin-top: 115px;
            }
            .tree-right{
                width: 50%;

            }

            .tree-center{
                margin: 65px 0 130px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                width: 3px;
                background-color: #bb0600;
                align-items: center;
                .circle{
                    background: #FFFFFF;
                    border: 5px solid #BB0600;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    position: relative;
                    z-index: 5;
                }
            }
            @media (max-width: 1440px) {
                .tree-item{
                    .tree-wrapper{
                        width: 400px;
                    }
                    .line{
                        width: calc(100% - 400px);
                    }
                }
            }
            @media (max-width: 1200px) {
                display: block;
                .tree-center{
                    display: none;
                }
                .tree-left, .tree-right{
                    width: 100%;
                    margin-top: 0;
                }
                .tree-item{
                    .line{
                        display: none;
                    }
                    .tree-wrapper{
                        width: 100%;
                    }
                }
            }
            @media (max-width: 576px) {
                .tree-item{
                    margin-bottom: 20px;
                    .tree-wrapper{
                        padding: 20px;
                        h4{
                            font-size: 16px;
                            line-height: 22px;
                        }
                        p{
                            font-size: 12px;
                            line-height: 19px;
                        }
                        .border{
                            display: none;
                        }
                        svg{
                            width: 50px;
                            height: 50px;
                        }
                    }
                }
            }
        }
        
    }

    .section-two{
        margin-top: 35px;

        .eld-cards{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 50px;
            margin-bottom: 100px;
            .card{
                width: 31%;
                background: rgba(0, 0, 0, 0.1);
                border: 2px solid #000000;
                border-radius: 6px;
                padding: 50px 35px;
                text-align: center;
                min-height: 410px;
                &:nth-child(2){
                    padding-top: 65px;
                }

                h3{
                    font-weight: 600;
                    font-size: 32px;
                    line-height: 44px;
                    margin-top: 20px;
                }
                p{
                    line-height: 27px;
                    margin-top: 16px;
                }
            }
            @media (max-width: 1440px) {
                .card{
                    h3{
                        font-size: 24px;
                    }
                }
            }   
            @media (max-width: 1200px) {
                flex-wrap: wrap;
                .card{
                     width: 48%;
                    margin-top: 20px;
                }   
            } 
            @media (max-width: 768px) {
                .card{
                     width: 100%;
                     min-height: initial
                }   
            } 
            @media (max-width: 576px) {
                margin-top: 0;
                .card{
                     padding:40px 30px;

                     svg{
                        width: 100px;
                        height: 100px;
                     }
                     p{
                        font-size: 12px;
                        line-height: 19px;
                     }
                }   
            } 
        }

    }

    .section-three{
        margin-top: 35px;
        position: relative;

        .shadow{
            background: linear-gradient(90deg, #000000 -5.42%, rgba(0, 0, 0, 0) 225.13%);
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .install{
            position: relative;
            padding: 65px 0;
            color: white;
            
            .install-item{
                display: flex;
                margin-top: 24px;
                gap: 28px;

                h2{
                    font-weight: 600;
                    font-size: 24px;
                    line-height: 33px;
                    margin-top: 8px;
                }
                p{
                    line-height: 26px;
                    color: #BBBBBB;
                    margin-top: 10px;
                    width: 50%;
                }
            }
            @media (max-width: 576px) {
               .install-item{
                    h2{
                        font-size: 16px;
                        line-height: 22px;
                    }
                    p{
                        font-size: 12px;
                        line-height: 19px; 
                        width: 100%;
                    }
                    svg{
                        width: 40px;
                        height: 40px;
                    }
               }
            }
        }
    }

    .section-four{
        padding-top: 100px;
        .driving{
            margin-top: 60px;
            display: flex;
            gap: 80px;
            align-items: center;

            .driving-left{
                width: 35%;

                img{
                    width: 100%;
                }
            }

            .driving-right{
                width: 65%;

                .driving-item{
                    display: flex;
                    gap: 20px;
                    margin-top: 35px;
                    p{
                        font-weight: 600;
                        font-size: 20px;
                        line-height: 27px;
                    }
                }

                .driving-card{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 40px;
                    gap: 45px;
                    .card{
                        background: rgba(0, 0, 0, 0.05);
                        border: 2px solid #000000;
                        border-radius: 8px;
                        padding: 50px 30px;
                        text-align: center;
                        min-height: 360px;

                       &:first-child svg{
                            width: 70px;
                            height: 70px;
                            path{
                                fill: black;
                            }
                        }

                        h3{
                            font-weight: 700;
                            font-size: 36px;
                            line-height: 49px;
                            margin-top: 20px;
                        }
                        p{
                            line-height: 27px;
                            margin-top: 14px;
                        }
                    }
                }
            }

            @media (max-width: 1200px) {
                display: block;

                .driving-left{
                    width :50%;
                }
                .driving-right{
                    width:100%;
                }
            }
            @media (max-width: 768px) {

                .driving-left{
                    width :100%;
                }
                .driving-right{
                    .driving-card{
                        display: block;

                        .card{
                            padding: 16px;
                            min-height: initial;
                        }
                    }
                    .driving-item{
                        p{
                            font-size: 16px;
                            line-height: 24px;
                        }
                    }
                }
            }
            @media (max-width: 576px) {
                margin-top: 25px;
                .driving-right{
                    .driving-card{
                        .card{
                            margin-top: 20px;
                        }
                    }
                }

            }

        }
    }

    .section-five{
        margin-top: 70px;
        position: relative;
        .status-top{
            p{
                font-size: 12px;
                line-height: 20px;
                margin-top: 20px;
                width: 40%;
            }
            @media (max-width:992px) {
                p{
                    width: 100%;
                }
            }
            @media (max-width:576px) {
                p{
                    display: none;
                }
            }
        }
            .status-next{
                display:none;
            }
            @media (max-width:768px) {
                .status-next{
                    position: relative;
                    display:block;
                    margin-top: 50px;
                    .samsung2{
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 70%;
                    }
                    .samsung1{
                        width: 60%;
                    }
                }
            }
        @media (max-width:576px) {
            .status-next{
                .samsung1{
                    width: 50%;
                }
                .samsung2{
                    width: 65%;
                }
            }
        }
        .status{
            position: relative;
            

            .shadow{
                position: absolute;
                width: 100%;
                background: linear-gradient(90deg, #000000 -15.03%, rgba(0, 0, 0, 0) 183.98%);
                height: 100%;
            }

            .status-main{
                position: relative;
                color: white;
                margin-top: 50px;
                display: flex;
                padding-top: 20px;
                align-items: center;

                .status-left{
                    width: 50%;

                    .status-item{
                        display: flex;
                        gap:20px;
                        margin: 70px 0;

                        h3{
                            font-weight: 600;
                            font-size: 32px;
                            line-height: 44px;
                            margin-top: 10px;
                        }

                        p{
                            line-height: 25px;
                            margin-top: 15px;
                            width: 80%;
                        }
                    }
                }
                .status-right{
                    width: 50%;
                    position: relative;

                    .samsung2{
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 70%;
                    }
                }
                @media (max-width:768px) {
                    display: block;
                    .status-left{
                        width: 100%;
                        padding-bottom: 90px;
                    } 
                    .status-right{
                        display:none;
                    }
                }
                @media (max-width:576px) {
                    .status-left{
                        .status-item{
                            svg{
                                width:50px;
                                height:50px;
                            }
                            p{
                                font-size: 14px;
                                line-height: 22px;
                                width: 100%
                            }
                            h3{
                                font-size: 20px;
                                line-height: 27px;

                            }
                        }
                    } 
                }
            }
           
        }
    }

    .section-six{
        margin-top: 100px;
        .log-next{
            display: none;
        }
        .log-main{
            margin-top: 50px;
            position: relative;
            .shadow{
                position: absolute;
                width: 100%;
                height: 100%;
                background: linear-gradient(270deg, #000000 0%, rgba(0, 0, 0, 0) 175.86%);
            }

            .log{
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                color: white;

                .log-left{
                    width: 70%;
                    display: flex;
                    position: relative;
                    padding-top: 150px;
                    justify-content: space-between;

                    .samsung3{
                        position: absolute;
                        left: 50%;
                        transform: translate(-50%);
                        height: 100%;
                        top:0;
                    }
                }

                .log-right{
                    width: 25%;

                    .log-item{
                        display: flex;
                        gap:20px;
                        margin: 35px 0;

                        h3{
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 33px;
                        }

                        p{
                            line-height: 25px;
                            margin-top: 5px;
                        }
                    }
                }

                @media (max-width:1440px) {
                    .log-left{
                        width: 60%;
                        .samsung1, .samsung2{
                            width: 48%
                        }
                    } 
                    .log-right{
                        width: 40%
                    }
                }
                @media (max-width:768px) {
                    .log-left{
                        display: none;
                    } 
                    .log-right{
                        width: 100%
                    }
                }
            }

        }

        @media (max-width:768px) {
            .log-next{
                display: flex;
                position: relative;
                margin-top: 180px;
                justify-content: space-between;
                .samsung3{
                        position: absolute;
                        left: 50%;
                        transform: translate(-50%);
                        /* height: 100%; */
                        bottom:0;
                        width: 55%;
                    }
                .samsung1, .samsung2{
                    width: 45%;
                }
            }
        }
    }

    .section-seven{
        margin-top: 100px;
        position: relative;
        .dvir-next{
            display: none;
        }

        .dvir-main{
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-top: 70px;
            /* gap:50px; */

            .dvir-list{
                width: 20%;
                display: flex;
                flex-direction: column;
                gap: 120px;

                .dvir-item{
                        display: flex;
                        gap:20px;

                        h3{
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 33px;
                        }

                        p{
                            line-height: 25px;
                            margin-top: 5px;
                        }
                    }
            }
            .dvir-img{
                width: 55%;
                display: flex;
                justify-content: space-between;
                position: relative;
                .samsung3{
                    position: absolute;
                    left: 20%;
                    transform: translateX(-50%);
                    bottom: -10px;
                    width: 60%
                }
                .samsung1, .samsung2{
                    width: 48%;
                }
            }
        }
        @media (max-width: 1200px) {
            .dvir-main{
                .dvir-img{
                    display: none;
                }
                .dvir-list{
                    width: 45%;
                    gap:20px;
                    margin-bottom: 20px;
                    .dvir-item{
                        h3{
                            font-size: 16px;
                            line-height: 22px;
                        }
                        p{
                            font-size: 12px;
                            line-height: 17px;  
                        }
                        svg{
                            width: 20px;
                            height: 20px;
                        }
                    }
                }
            }
            .dvir-next{
                margin-top: 200px;
                width: 100%;
                display: flex;
                justify-content: space-between;
                position: relative;
                .samsung3{
                    position: absolute;
                    left: 20%;
                    transform: translateX(-50%);
                    bottom: -10px;
                    width: 60%
                }
                .samsung1, .samsung2{
                    width: 48%;
                }
            }
        }
        @media (max-width: 576px) {
            .dvir-next{
                margin-top: 120px;
            }
            .dvir-main{
                display: block;
                .dvir-list{
                    width: 100%;
                }
            }
        }
    }

    .section-eight{
        margin-top: 100px;

        .easy-main{
            display: flex;
            justify-content: space-between;

            .easy-item{
                width: 28%;
                text-align: center;
                margin-top: 50px;

                img{
                    width: 100%;
                }
                h2{
                    font-weight: 600;
                    font-size: 30px;
                    line-height: 40px;
                    margin-top: 35px;
                }
            }
            @media (max-width: 992px) {
                flex-wrap: wrap;
                .easy-item{
                    width: 48%;
                    h2{
                        font-size: 24px;
                    }
                }
            }
            @media (max-width: 576px) {
                padding: 0 40px;
                .easy-item{
                    width: 100%;
                    h2{
                        font-size: 20px;
                        line-height: 27px;
                        margin-top: 16px;
                    }
                }
            }
        }
    }

    .section-nine{
        margin-top: 100px;

        .dashboard-main{
            margin-top: 50px;
            text-align: center;

            .macbook{
                width: 70%;
            }

            .dashboard-card{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 50px;
                .card{
                    width: 31%;
                    background: rgba(0, 0, 0, 0.1);
                    border: 2px solid #000000;
                    border-radius: 6px;
                    padding: 50px 35px;
                    text-align: center;
                    min-height: 410px;
                    &:nth-child(2){
                        padding-top: 65px;

                        h3{
                            margin-top: 32px;
                        }
                    }

                    h3{
                        font-weight: 600;
                        font-size: 32px;
                        line-height: 44px;
                        margin-top: 20px;
                    }
                    p{
                        line-height: 27px;
                        margin-top: 16px;
                    }
                }
            }
            @media (max-width: 992px) {
                .dashboard-card{
                    flex-wrap: wrap;
                    padding: 0 50px;
                    .card{
                        width: 100%;
                        margin-top: 20px;
                    }
                }
            }
            @media (max-width: 576px) {
                .macbook{
                    width: 100%;
                }
                .dashboard-card{
                    padding: 0;
                    .card{
                        padding: 30px 15px;
                        min-height: initial;
                        h3{
                            font-size: 24px;
                            line-height: 33px;
                        }
                        p{
                            font-size: 16px;
                            line-height: 27px;
                        }
                        svg{
                            width: 100px;
                            height: 100px;
                        }
                    }
                }
            }
        }
    }

    .section-ten{
        margin-bottom: 100px;
    }
`